const colors = {
    main: '#006dff',
    white: '#fff'
}

export default colors;